import React from 'react';

function PricingPaid() {
    return (
        <>
            <div className='py-5 px-6 has-text-centered greyBox is-flex is-flex-direction-column is-justify-content-space-between'>
                <div className='is-flex is-flex-direction-column is-justify-content-space-between'>
                    <div>
                        <h3 className='py-2 m-0'>Heavyweight hero</h3>
                        <p className='pb-0 mb-0'>All the bells, whistles, and the secret sauce that makes you look like you've got your life together.</p>
                    </div>
                    <div>
                        <h1 className='m-0 py-5 colorBlack border-bottom'>$3/mo</h1>
                        <div className='mt-3 mb-3'>
                            <p className='my-2 pt-3 is-semibold'>Features include</p>
                            <p className='my-1 p-0'>Unlimited Nudges</p>
                            <p className='my-1 p-0'>Snooze Nudges</p>
                            <p className='my-1 p-0'>Recurring Nudges</p>
                            <p className='my-1 p-0'>Nudges with attachments</p>
                        </div>
                    </div>
                </div>
                <div className="py-5 button-container">
                    <a href="/sign-up" className="button">Take me to the big leagues</a>
                </div>
            </div>
        </>
    )
}

export default PricingPaid;